'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HashSet = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _fp = require('lodash/fp');

var _fp2 = _interopRequireDefault(_fp);

var _Option = require('./Option');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HashSet = exports.HashSet = function () {
  function HashSet() {
    _classCallCheck(this, HashSet);

    this.vals = {};

    for (var _len = arguments.length, lst = Array(_len), _key = 0; _key < _len; _key++) {
      lst[_key] = arguments[_key];
    }

    for (var i = 0; i < lst.length; i += 1) {
      this.vals[lst[i].hash()] = lst[i];
    }
    this.size = Object.values(this.vals).length;
  }

  _createClass(HashSet, [{
    key: 'has',
    value: function has(item) {
      return (0, _Option.isSomething)(this.vals[item.hash()]);
    }
  }, {
    key: 'difference',
    value: function difference(rside) {
      return new (Function.prototype.bind.apply(HashSet, [null].concat(_toConsumableArray(_fp2.default.filter(function (x) {
        return !rside.has(x);
      })(this.values())))))();
    }
  }, {
    key: 'union',
    value: function union(rside) {
      return new (Function.prototype.bind.apply(HashSet, [null].concat(_toConsumableArray(this.values().concat(rside.values())))))();
    }
  }, {
    key: 'equals',
    value: function equals(rside) {
      if (this.size !== rside.size) return false;

      var thisArr = this.values();
      for (var i = 0; i < thisArr.length; i += 1) {
        if (!rside.has(thisArr[i])) return false;
      }
      var rsideArr = this.values();
      for (var _i = 0; _i < rsideArr.length; _i += 1) {
        if (!this.has(rsideArr[_i])) return false;
      }
      return true;
    }
  }, {
    key: 'values',
    value: function values() {
      return Object.values(this.vals);
    }
  }]);

  return HashSet;
}();


//////////////////
// WEBPACK FOOTER
// ./node_modules/luminescent-dreams-base/lib/HashSet.js
// module id = 753
// module chunks = 0